import React from "react"
import {useSelector} from "react-redux";
import {useFormContext} from "react-hook-form";
import classNames from "classnames";

const NiceCheckboxStyle = ({color, errorColor}) => {
  return <>
    <style>
      {`
      .check-box-container {
        position: relative;
        padding-left: 35px;
        cursor: pointer;
        font-size: 0.875rem;
        color: #212a34;
        font-size: medium;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        text-align: left;
        padding-top: 0.5px;
        margin-right: 2%;
        min-width: 100%;
      }
      
      .check-box-container.invalid {
        color: ${errorColor};
      }
      
      .check-box-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
      }
      
      .check-box-container input:checked ~ .checkmark {
        border-color: ${color};
      }
      
      .check-box-container input:checked ~ .checkmark:after {
        display: block;
      }
      
      .check-box-container:hover input ~ .checkmark {
        filter: brightness(0.8);
      }
      
      .check-box-container .checkmark:after {
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px;
        border: solid ${color};
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }
      
      .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: transparent;
        border: 2px solid ${color};
      }
      
      .is-invalid .checkmark {
        border-color: ${errorColor};
      }
      
      .checkmark:after {
        content: "";
        position: absolute;
        display: none;
      }
    `}
    </style>
  </>
}


const CustomBoostrapRadioButtonCheckbox = ({
                                             name,
                                             type,
                                             label,
                                             option,
                                             variant,
                                             readOnly,
                                             errorMessage,
                                             onChange
                                           }) => {
  const color = useSelector(state => state.material_ui_color) || "#0069D9"
  const errorColor = "#e6364b"
  const disabledColor = "#6c757d"

  const {register} = useFormContext();
  const labelWidth = useSelector(state => state.label_width) || "3"
  const isHorizontal = variant !== "vertical"

  let labelColor = ""

  if (errorMessage) {
    labelColor = "#dc3545"
  } else if (readOnly || option.disabled) {
    labelColor = disabledColor
  }

  const labelStyle = {
    display: isHorizontal ? "inline-block" : "block",
    color: labelColor,
  };

  return <div key={`${name}_option_${option.value}`}>
    <NiceCheckboxStyle
      color={color}
      errorColor={errorColor}
      isHorizontal={isHorizontal}
    />
    <label
      htmlFor={`${name}_option_${option.value}`}
      style={labelStyle}
      className={classNames("r-label form-check-label check-box-container", {
        [`col-md-${labelWidth} col-form-label-sm`]: isHorizontal,
        "is-invalid": errorMessage
      })}>
      {option.label}
      <input
        {...register(name,{
          onChange: onChange
        })}
        id={`${name}_option_${option.value}`}
        type={type}
        value={option.value}
        disabled={readOnly || option.disabled}
        className={classNames("form-check-input", {"is-invalid": errorMessage})}
      />
      <span className={"checkmark"} style={{borderColor: readOnly || option.disabled ? disabledColor : ""}}/>
    </label>
  </div>
}

export default CustomBoostrapRadioButtonCheckbox
